<template>
  <div class="forget-password-component-container">
    <div class="component-wrapper">
      <LoginHeader />
      <div class="forget-password-page-container scroll-bar">
        <div v-if="showForgetPasswordPage" class="forget-password-form-container">
          <div class="form-container">
            <form class="forget-password-form" @submit="forgetPasswordHandle">
              <div class="info-text-container">
                <!-- <p class="info-text">
                  Wachtwoord vergeten?
                </p> -->
                <p class="info-text">
                  {{ $t('forget_password') }}
                </p>
                <!-- <p class="info-text">
                  Vul je emailadres in dat bij je fit20 trainer bekend is.
                </p> -->
                <p class="info-text">
                  {{ $t('enter_email_address_known_to_trainer') }}
                </p>
              </div>
              <div class="input-container">
                <div class="form-section-wrapper">
                  <input id="email" class="form-input" :class="[{'error-unknown-email': unknownEmailAddress, 'blocked': sendingEmailLoading}]"
                    name="email" type="email" :placeholder="$t('enter_email_address') + '...'"
                    required />
                </div>
                <div class="sending-email-err-msg-container">
                  <p v-if="unknownEmailAddress" class="red">{{ $t(`${sendingEmailErrMsg}`) }}</p>
                </div>
              </div>
              <div class="reset-password-text-container">
                <!-- <p>
                  Je ontvangt een bevestigingsmail met een link om je wachtwoord te resetten.
                </p> -->
                <p>
                  {{ $t('receive_confirm_email_to_reset_password') }}
                </p>
              </div>

              <div class="form-section-wrapper send-btn-and-error-msg-container">
                <div class="send-btn-wrapper">
                  <div v-if="sendingEmailLoading" class="loading-spinner-container">
                    <!-- <div class="circular-progress-indicator"></div> -->
                    <div class="spinner">
                        <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
                    </div>
                  </div>
                  <input v-else id="send-btn" class="send-btn btn" type="submit" :value="$t('send')" />
                </div>
                <div class="error-send-email-msg-container">
                  <p v-if="sendingEmailFailed && !unknownEmailAddress" class="error-send-email-msg red">{{ $t(`${sendingEmailErrMsg}`) }}</p>
                </div>
              </div>
            </form>

            <div class="can-not-reset-password-text-container">
              <!-- <p>Lukt het versturen niet?</p> -->
              <p>{{ $t('send_confirm_email_not_possible') }}</p>
              <!-- <p>Vraag hulp bij je fit20 trainer.</p> -->
              <p>{{ $t('ask_trainer_for_hulp') }}</p>
            </div>
          </div>
        </div>
        <div v-else class="send-reset-password-email-success-container">
          <div class="send-reset-password-email-success-content-container">
            <div class="info-text-container">
              <p class="info-text">
                <!-- Er is een email verstuurd met daarineen link om je wachtwoord te resetten. -->
                {{ $t('reset_password_email_sent') }}
                <br><br>
                <!-- Tot snel! -->
                {{ $t('see_you_soon') }}
              </p>
            </div>
            <div class="login-btn-container">
              <!-- <p>Account geactiveerd?</p> -->
              <p>{{ $t('account_activated') }}</p>
              <!-- <div class="login-btn" @click="goToLoginPage">Login</div> -->
              <div class="login-btn" @click="goToLoginPage">{{ $t('login') }}</div>
            </div>
          </div>
        </div>
      </div>
      <LoginFooter />
    </div>
  </div>
</template>

<script>
import LoginHeader from './LoginHeader.vue';
import LoginFooter from './LoginFooter.vue';
export default {
  name: 'ForgetPasswordPage',
  props: {
    // displayForgetPasswordPage: Boolean,
  },
  components: {
    LoginHeader,
    LoginFooter,
  },
  data() {
    return {
      email: '',
      sendingEmailLoading: false,
      showForgetPasswordPage: true,
      sendingEmailFailed: false,
      sendingEmailErrMsg: '',
      unknownEmailAddress: false,
    };
  },
  methods: {
    goBack: function () {
      history.back();
    },
    goToLoginPage: function () {
      this.resetStates();
      this.$store.backToLoginPage();
    },
    resetStates: function() {
      this.email = '';
      this.sendingEmailLoading = false;
      this.showForgetPasswordPage = true;
      this.sendingEmailFailed = false;
      this.sendingEmailErrMsg = '';
      this.unknownEmailAddress = false;
    },
    forgetPasswordHandle: async function (e) {
      e.preventDefault();

      this.resetStates();

      this.sendingEmailLoading = true;

      const email = document.getElementById('email').value;
      if (!email || email  === '') {
        this.sendingEmailLoading = false;
        this.sendingEmailFailed = true;
        this.unknownEmailAddress = true;
        this.sendingEmailErrMsg = 'enter_email_address';
      }
      else {
        const data = {
          email,
          appLang: this.$store.selectedAppLanguage,
        };

        try {
          const forgetPasswordResponse = await fetch('api/user/forgetPassword', {
            method: "POST",
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
            },
            body: JSON.stringify(data),
          });

          const forgetPasswordResponseJson = await forgetPasswordResponse.json();

          if (!forgetPasswordResponseJson.status) {
            if (forgetPasswordResponseJson.unknownEmailAddress) {
              this.unknownEmailAddress = true;
            }
            this.sendingEmailFailed = true;
            this.sendingEmailErrMsg = forgetPasswordResponseJson.message;
          }
          else {
            this.email = email;
            this.showForgetPasswordPage = false;
            this.$store.showFooterBackBtn = false;
          }
          this.sendingEmailLoading = false;
        }
        catch (err) {
          console.log("Something went wrong!");
          console.log(err);
          this.sendingEmailLoading = false;
          this.sendingEmailFailed = true;
          this.sendingEmailErrMsg = "something_went_wrong_try_again";
        }

      }
    }
  },
  async created() {
    // const loggedInUser = await this.$store.checkLoggedinUser();
    // if (loggedInUser) {
    //   this.$router.push('/home');
    // }
  }
};
</script>

<style>
.forget-password-component-container {
  position: relative;
  height: 100vh;
  width: 100%;
  /* border: 1px solid red; */
}

.forget-password-component-container .component-wrapper {
  height: 100vh;
  display: flex;
  flex-direction: column;
  /* border: 1px solid red; */
}

.forget-password-component-container .forget-password-page-container {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: auto;
  /* border: 1px solid red; */
}

.forget-password-component-container .forget-password-form-container {
  width: 88%;
  max-width: 500px;
  height: 100%;
}

.forget-password-component-container .form-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  /* border: 1px solid red; */
}

.forget-password-component-container .forget-password-form {
  /* flex: 1; */
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  /* border: 1px solid blue; */
}

.forget-password-component-container .info-text-container {
  width: 100%;
  max-width: 350px;
  padding: calc(11%) 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* border: 1px solid red; */
}

.forget-password-component-container .info-text-container .info-text {
  width: 100%;
  font-size: 30px;
  font-family: 'VAG Rounded Std', sans-serif;
  color: #a0a1a3;
  text-align: center;
  line-height: 35px;
  /* border: 1px solid red; */
  /* padding-bottom: 15px; */
}

.forget-password-component-container .input-container {
  width: 100%;
  height: 70px;
  /* border: 1px solid red; */
}

.forget-password-component-container .form-input {
  width: 100%;
  padding: 8px 6px 6px 8px;
  font-family: 'Open Sans Std', sans-serif;
  font-size: 16px;
  border: 1px solid #92d400;
  border-radius: 10px;
  color: #000000;
  display: inline-block;
  /* margin-bottom: 15px; */
}

.forget-password-component-container .form-input:focus {
  outline: 1px solid #92d400;
}

.forget-password-component-container input::placeholder,
.forget-password-component-container textarea::placeholder {
  color: #a0a1a3;
}

.forget-password-component-container .error-unknown-email {
  border: 1px solid #cb061d;
}

.forget-password-component-container .error-unknown-email:focus {
  outline: 1px solid #cb061d;
}

.forget-password-component-container .sending-email-err-msg-container {
  padding: 2px 8px;
  font-size: 12px;
  font-family: 'Open Sans Std', sans-serif;
  word-wrap: break-word;
}

.forget-password-component-container .reset-password-text-container {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding: 15px 0 0px;
  /* border: 1px solid; */
}

.forget-password-component-container .reset-password-text-container p {
  width: 100%;
  max-width: 325px;
  text-align: center;
  color: #616365;
  font-family: 'Open Sans Std', sans-serif;
  font-size: 16px;
  padding: 10px 0;
}

.forget-password-component-container .send-btn-and-error-msg-container {
  width: 100%;
  height: 75px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.forget-password-component-container .send-btn-wrapper {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* border: 1px solid red; */
}

.forget-password-component-container .send-btn {
  background: #92d400;
  color: #ffffff;
  font-family: 'VAG Rounded Std', sans-serif;
  font-size: 29px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  padding: 6px 50px;
  /* border: 1px solid red; */
}

[dir="rtl"] .forget-password-component-container .send-btn {
    font-size: min(26px, calc(14px + 2vw));
    padding: 4px 50px;
    max-height: 45px;
}

.forget-password-component-container .loading-spinner-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* border: 1px solid red; */
}

.forget-password-component-container .error-send-email-msg-container {
  /* height: 20px; */
  text-align: center;
}

.forget-password-component-container .error-send-email-msg-container p {
  padding: 4px 8px;
  font-size: 12px;
  font-family: 'Open Sans Std', sans-serif;
  word-wrap: break-word;
}

.forget-password-component-container .can-not-reset-password-text-container {
  /* flex: 0.13; */
  display: flex;
  flex-direction: column;
  /* justify-content: start; */
  align-items: center;
  text-align: center;
  padding: 5px 0 25px;
  /* border: 1px solid red; */
}

.forget-password-component-container .can-not-reset-password-text-container p {
  color: #616365;
  font-family: 'Open Sans Std', sans-serif;
  font-size: 16px;
}

.forget-password-component-container .send-reset-password-email-success-container {
  width: 88%;
  max-width: 500px;
  height: 100%;
}

.forget-password-component-container .send-reset-password-email-success-content-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.forget-password-component-container .login-btn-container {
    flex: 1.5;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Open Sans Std', sans-serif;
}

.forget-password-component-container .login-btn-container p {
    color: #616365;
    padding: 5px 0;
}

.forget-password-component-container .login-btn {
    width: 50%;
    min-width: 200px;
    color: #fff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 28px;
    text-align: center;
    letter-spacing: 1px;
    padding: 6px 0 10px;
    background: #009df4;
    border: 1px solid #fff;
    border-radius: 30px;
    cursor: pointer;
}

[dir="rtl"] .forget-password-component-container .login-btn {
    font-size: min(26px, calc(14px + 2vw));
    max-height: 45px;
    padding: 4px 25px;
}

@media (max-width: 425px) {
  .forget-password-component-container .info-text-container {
    max-width: 320px;
  }

  .forget-password-component-container .info-text-container .info-text {
    font-size: calc(12px + 4vw);
  }

  .forget-password-component-container .form-input {
    font-size: 14px;
  }

  .forget-password-component-container .sending-email-err-msg-container,
  .forget-password-component-container .error-send-email-msg-container p {
    font-size: calc(6px + 1.5vw);
  }

  .forget-password-component-container .reset-password-text-container p,
  .forget-password-component-container .can-not-reset-password-text-container p {
    max-width: 275px;
    font-size: calc(10px + 1vw);
  }

  .forget-password-component-container .send-btn {
    font-size: 26px;
    padding: 6px 40px;
  }

  .forget-password-component-container .login-btn-container p {
    font-size: 14px;
  }
}

@media (max-width: 320px) {
  .forget-password-component-container .info-text-container {
    max-width: 90%;
  }

  .forget-password-component-container .info-text-container .info-text {
    font-size: calc(10px + 3.7vw);
  }

  .forget-password-component-container .login-btn-container p {
    font-size: 14px;
  }
}

</style>